import React, {useContext} from "react";
import {SuggestionsPopupLogic} from "./SuggestionsPopup.logic";
import {SuggestionsPopupRendering} from "./SuggestionsPopup.rendering";
import {Props} from "./SuggestionsPopup.interfaces";
import {AppContext, IAppContextState} from "../../../../services/AppContext";

const SuggestionsPopup = (props: Props): JSX.Element => {
    const context = useContext<IAppContextState>(AppContext);

    return (
        <SuggestionsPopupLogic {...props} teamsContext={context.teams}>
            {logic => <SuggestionsPopupRendering {...logic}/>}
        </SuggestionsPopupLogic>
    )
}

export default SuggestionsPopup;